export default {"src":"/_next/static/media/identification.3271b5c4.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};